import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'sn-partner-type-1';

/**
 * Partner attribution card for named boutique integrators with a large logo.
 * Single-column card with a light-blue background; on desktop the partner logo is positioned absolutely in the top-right corner, freeing the left side for a two-paragraph description.
 * Use when the partner has a prominent brand and supplies two descriptive paragraphs (e.g. NavLabs / Appian integration pages).
 *
 * @product signnow
 * @source partner
 * @version 1.0.0
 * @category SignNow
 * @contentConfig Partner attribution card with large logo (220 px desktop) and two-paragraph message
 * @slot logo - <me-picture> - Partner logo, positioned top-right on desktop
 * @slot heading - {required}, <me-heading variant="2" tag="h2"> - Partner heading
 * @slot message - <me-text> - Partner description (supports two paragraphs via innerHTML)
 * @example
 *   <sn-partner-type-1>
 *     <me-picture slot="logo" src-set="https://marketing-static.signnow.com/284/images/_pages/integration/navlabs-logo.svg" alt="NavLabs logo"></me-picture>
 *     <me-heading slot="heading" variant="2" tag="h2">Built by NavLabs: Leaders in Appian Innovation</me-heading>
 *     <me-text slot="message" tag="div"></me-text>
 *   </sn-partner-type-1>
 */
@Component({
  tag: 'sn-partner-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNPartnerType1 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <me-section class={COMPONENT_NAME} yGap="2xl" yGapLg="5xl">
          <div class={`${COMPONENT_NAME}__row`}>
            <div class={`${COMPONENT_NAME}__logo`}>
              <slot name="logo"></slot>
            </div>
            <slot name="heading"></slot>
            <div class={`${COMPONENT_NAME}__message`}>
              <slot name="message"></slot>
            </div>
          </div>
        </me-section>
      </Host>
    );
  }
}
